import { useCallback } from 'react';

import { ACCESS_TOKEN, ISessionTime, SESSION_TIME, useLocalStorage, useSessionStorage } from '@hsp/react-hooks';
import { IAuthenticationToken } from '@hsp/utilities';

import { useAppDispatch } from 'hooks/store';
import { LoginActions } from 'store/actions';

export const useEndSession = () => {
  const dispatch = useAppDispatch();
  const [, setToken] = useLocalStorage<IAuthenticationToken>(ACCESS_TOKEN, null);
  const [, setSessionTime] = useSessionStorage<ISessionTime>(SESSION_TIME, null);

  const endSession = useCallback(() => {
    dispatch(LoginActions.logoff());
    setSessionTime(null);
    setToken(null);
  }, [dispatch, setSessionTime, setToken]);
  const endSessionAsync = useCallback(() => {
    return new Promise<void>((resolve) => {
      endSession();
      resolve();
    });
  }, [endSession]);

  return {
    endSession,
    endSessionAsync,
  };
};
